export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        description: value.description
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        name: value.name,
        description: value.description
      })
    }
  },
  CURRENT (state, value) {
    if (value) {
      for (const prop of ['id', 'name', 'description']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.tagCount = value.tagCount || 0
    } else {
      state.current = {
        id: '',
        name: '',
        description: '',
        tagCount: 0
      }
      state.update = {
        id: '',
        name: '',
        description: ''
      }
    }
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  UPDATE_DESCRIPTION (state, value) {
    state.update.description = value
  }
}
